import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Wraps any estimated dollar impact to add the required "Estimated" label
export function EstimatedAmount({ amount, className = '' }: { amount: number; className?: string }) {
  const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(amount);
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="font-semibold">~{formatted}/mo</span>
      <span className="text-xs text-amber-600 font-normal flex items-center gap-0.5">
        <AlertTriangle size={10} />
        Est.
      </span>
    </span>
  );
}

